import { isApiFetchError } from '@borradh-workspace/api-client';

export function getOpeningHoursConfirmation(error: unknown): {
  token: string;
  affectedStaffCount: number;
  affectedBookingCount: number;
} | null {
  if (
    !isApiFetchError(error) ||
    error.status !== 409 ||
    error.details?.confirmationRequired !== true ||
    typeof error.details.impactToken !== 'string'
  )
    return null;
  return {
    token: error.details.impactToken,
    affectedStaffCount:
      typeof error.details.affectedStaffCount === 'number'
        ? error.details.affectedStaffCount
        : 0,
    affectedBookingCount:
      typeof error.details.affectedBookingCount === 'number'
        ? error.details.affectedBookingCount
        : 0,
  };
}
